<script>
	import { onMount } from "svelte";
	import * as m from "@app/paraglide/messages.js";
	import {
		themeState,
		setAppTheme,
		initAppTheme,
		handleSystemThemeChange
	} from "@app/store/themeStore.svelte.js";

	/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
	let { currentState, toggleMenu } = $props();

	function handleToggleMenu() {
		toggleMenu("theme");
	}

	onMount(() => {
		initAppTheme();
		window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handleSystemThemeChange);
	});
</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
	<a onclick={handleToggleMenu} class="dropdown-toggle nav-link" href="#!/" id="themeMenu" aria-haspopup="true" aria-expanded={currentState} aria-label={m.theme_selection()}><i class="bi bi-sun-fill" aria-hidden="true"></i></a>
	<div class="dropdown-menu {currentState ? 'show' : ''}" aria-labelledby="themeMenu" role="menu">
		<a class="dropdown-item {themeState.mode === 'light' ? 'active' : ''}" href="#!/" onclick={() => setAppTheme('light')} role="menuitem" id="lightThemeBtn"><i class="bi bi-sun-fill" aria-hidden="true"></i> {m.light()}</a>
		<a class="dropdown-item {themeState.mode === 'dark' ? 'active' : ''}" href="#!/" onclick={() => setAppTheme('dark')} role="menuitem" id="darkThemeBtn"><i class="bi bi-moon-stars-fill" aria-hidden="true"></i> {m.dark()}</a>
		<a class="dropdown-item {themeState.mode === 'auto' ? 'active' : ''}" href="#!/" onclick={() => setAppTheme('auto')} role="menuitem" id="autoThemeBtn"><i class="bi bi-circle-half" aria-hidden="true"></i> {m.auto_theme()}</a>
	</div>
</li>
